// src/App.js
import React, { useEffect, useRef } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./Redux/Store/store";
import Routes from "./AppRoutes/Routes";
import { HelmetProvider } from "react-helmet-async";
import { notification, Typography } from "antd";
import { Box, Button, ThemeProvider } from "@mui/material";
import appstore from "./Images/appstore.png";
import googleplay from "./Images/playstore.png";
import theme from "./theme";

function App() {
  const hasShownNotification = useRef(false);
  useEffect(() => {
    // Check if the user is on a mobile device
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    if (window.innerWidth <= 560 && isMobile &&  !hasShownNotification.current) {
      // Show toast notification
      notification.info({
        message: (
          <>
            <Typography variant="body2">
              For a better experience, please download our mobile application.
            </Typography>
          </>
        ),

        description: (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                marginLeft: 0,
                gap: 2,
              }}
            >
              <Button
                sx={{ cursor: "pointer", marginRight: { xs: 4, sm: 0 } }}
                type="primary"
                onClick={() =>
                  (window.location.href = "https://apps.apple.com/pk/app/gx-tickets/id6745892471")
                }
              >
                <a
                  href="https://apps.apple.com/us/app/dummy-app/id1234567890"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={appstore} alt="App Store" height="32" />
                </a>
              </Button>
              <Button sx={{ cursor: "pointer" }} type="primary">
                <a
                  href="https://play.google.com/store/apps/details?id=com.dummyapp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={googleplay}
                    alt="Google Play"
                    height="32"
                    href="https://play.google.com/store/apps/details?id=com.dummyapp"
                    target="_blank"
                  />
                </a>
              </Button>
            </Box>
          </>
        ),
        duration: 0, // Keep the notification open until closed manually
      });
      hasShownNotification.current = true; // Set the flag to true after showing the notification
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <HelmetProvider>
          <Router>
            <Routes />
          </Router>
        </HelmetProvider>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
